import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function VisionSection() {
    const { t } = useTranslation();
    return (

        <section className="relative py-[40px]">
            <div className="main-title">{t("Vision Perfected")}</div>
            <div className="container mx-auto px-6 text-center relative z-10">
                <p
                    className="text-[#bc8c39] text-xl max-w-3xl mx-auto mb-12"
                >
                    {t("OMA’s Clear+ Polarized™ technology redefines clarity, crafted in Japan’s premier optical labs.")}
                </p>
                <div
                    className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 max-w-5xl mx-auto"
                >
                    {[
                        t("Crystal-clear vision"),
                        t("100% UV protection"),
                        t("Glare-free comfort"),
                        t("Vivid color enhancement"),
                    ].map((feature, index) => (
                        <div
                            key={index}
                            className="p-6 bg-white bg-opacity-10 backdrop-blur-lg rounded-xl shadow-lg hover:shadow-xl hover:scale-105 transition-all border-2 border-gradient"
                        >
                            <span className="text-[#b58630] text-3xl mb-4 block">✓</span>
                            <p className="text-[#bc8c39] text-lg">{feature}</p>
                        </div>
                    ))}
                </div>
                <div
                    className="mt-12"
                >
                    <Link
                        to="/brands"
                        className="inline-block bg-[#b58630] text-white py-4 px-8 rounded-full font-bold text-lg hover:bg-[#a57729] hover:scale-105 transition-all glow"
                    >
                        {t("Explore Our Technology")}
                    </Link>
                </div>
            </div>
        </section>
    );
}